<template>
  <div class='btn'>
    <div class="left"></div>
    <div class="center">
      <img class="btnIcon" :src="require(`../../assets/button/${props.icon}.svg`)"/>
      {{props.text}}
    </div>
    <div class="right"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  icon:{
    type:String
  },
  text:{
    type:String,
    default:''
  }
})
</script>

<style lang="less" scoped>
.btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  cursor: pointer;
  height: 40px;
  color: #FFF;
  font-size: 14px;
  .btnIcon{
    height: 20px;
    width: 20px;
  }
  .left{
    background-image: url('../../assets/button/btn-left.svg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 15px;
    height: 100%;
  }
  .center{
    background-image: url('../../assets/button/btn-center.svg');
    height: 100%;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .right{
    background-image: url('../../assets/button/btn-right.svg');
    background-repeat: repeat;
    background-size: 100% 100%;
    width: 15px;
    height: 100%;
  }
}
</style>